import React, { useRef, useState, useEffect } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import '../styles/metrics.css';

function AnimatedNumber({ target, suffix = '', duration = 2000 }) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [started]);

  useEffect(() => {
    if (!started) return;

    const startTime = performance.now();
    const step = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [started, target, duration]);

  return <span ref={ref}>{started ? count : target}{suffix}</span>;
}

const metrics = [
  { value: 5, suffix: '+', label: 'Years building\nin DeFi' },
  { value: 12, suffix: '+', label: 'Years building\nin Finance' },
  { value: 4, suffix: '+', label: 'PhD\nengineers' },
  { value: 100, suffix: '%', label: 'Frontier\ninfrastructure' },
];

function Metrics() {
  const ref = useRef(null);
  useScrollReveal(ref);

  return (
    <section className="metrics" ref={ref}>
      <div className="metrics-grid">
        {metrics.map((metric, index) => (
          <div
            key={metric.label}
            className="metrics-item reveal"
            style={{ transitionDelay: `${index * 100}ms` }}
          >
            <span className="metrics-value">
              <AnimatedNumber target={metric.value} suffix={metric.suffix} />
            </span>
            <span className="metrics-label">{metric.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Metrics;
